import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
import { Divider } from "./Divider.js";
import { ConcealedAction } from "./ConcealedAction.js";
import { Group } from "./Group2.js";
import { Item } from "./Item.js";
function List({
  children,
  isContained = false,
  ...props
}) {
  return /* @__PURE__ */ jsx(ListStyled, {
    $isContained: isContained,
    ...props,
    children
  });
}
List.Group = Group;
List.Item = Item;
List.Divider = Divider;
List.ConcealedAction = ConcealedAction;
const ListStyled = styled.div.withConfig({
  displayName: "ListStyled",
  componentId: "sc-kyt0j-0"
})(["padding:", ";"], (props) => props.$isContained ? `0 ${token.spacing5}` : `${token.spacing3} 0`);
export {
  List
};
//# sourceMappingURL=List.js.map
